// biome-ignore lint/style/useFilenamingConvention: TanStack Router uses $param convention for dynamic routes
import { createRoute } from '@tanstack/react-router';
import { AccessGuard } from '@/components/guards/access-guard';
import { AuthGuard } from '@/components/guards/auth-guard';
import { TransitDetailPage } from '@/pages/transits/transit-detail-page';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: 'transits/$id',
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <TransitDetailPage />
      </AccessGuard>
    </AuthGuard>
  ),
  staticData: { titleKey: 'Transits' },
});
